import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";
import { packageCountries, packageGroupTypes } from "../packageTagsInfo";
import { TransportationName } from "../transportation";

interface Props {
  readonly forPackage: PublicPackageResponse;
}

export const ParametersAndRoute: FC<Props> = ({ forPackage }) => {
  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 1, border: "1px solid rgba(0,0,0,0.08)", mb: 3 }}>
      <Typography
        variant="subtitle2"
        sx={{
          textTransform: "uppercase",
          fontWeight: "bold",
          color: "text.secondary",
          mb: 2,
        }}
      >
        Parametry wycieczki
      </Typography>
      <Stack spacing={2}>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            Długość
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "500",
            }}
          >
            {forPackage.numberOfDays} dni
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
            }}
          >
            Transport
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "500",
            }}
          >
            <TransportationName forPackage={forPackage} />
          </Typography>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              mb: 1,
              display: "block",
            }}
          >
            Odwiedzane kraje
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {packageCountries(forPackage).map((c) => (
              <Chip key={c} label={c} size="small" />
            ))}
          </Box>
        </Box>
        <Box sx={{ pt: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              mb: 1,
              display: "block",
            }}
          >
            Polecamy dla grup
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {packageGroupTypes(forPackage).map((g) => (
              <Chip key={g} label={g} size="small" variant="outlined" />
            ))}
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};
